import { Theme, useMediaQuery } from "@mui/material";
import { Fragment, useCallback } from "react";
import { TextField, DatagridConfigurable, List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../shared/components/core/CoreCreateButton";
import { normativeExporter } from "../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_NORMATIVE_C" />
        <SortButton fields={['name']} />
        <FilterButton />
        <SacopExportButton exporter={normativeExporter} />
    </TopToolbar>
);

const sectorFilters = [
    <SearchInput source="q" alwaysOn />,

    <TextInput source="name" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const { filterValues, setFilters, displayedFilters } = listContext;
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    const handleChange = useCallback(
        (event: React.ChangeEvent<{}>, value: any) => {
            setFilters &&
                setFilters(
                    { ...filterValues, status: value },
                    displayedFilters,
                    false // no debounce, we want the filter to fire immediately
                );
        },
        [displayedFilters, filterValues, setFilters]
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="rol" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const NormativeList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        sort={{ field: 'name', order: 'DESC' }}
        perPage={25}
        filters={sectorFilters}
        actions={<ListActions />}
        exporter={normativeExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default NormativeList;
